import {TrackingEvent as CollapsibleTrackingEvent} from '../../components/collapsible/tracking';
import {
  FlattenedResourceTrackingEvent,
  TrackingEvent as EventSectionTrackingEvent,
} from '../query-events-section/tracking';
import {TrackingEvent as PropertiesMenuTrackingEvent} from '../query-block/properties-menu/tracking';
import {TrackingEvent as CohortsQueryBuilderTrackingEvent} from '../../widgets/cohorts-query-builder/util/tracking';
import {TRACKING_EVENTS as CustomPropertyModelTrackingEvent} from '../../widgets/custom-property-modal';
import {TRACKING_EVENTS as QueryBlockTrackingEvent} from '../../widgets/query-block/constants';

export enum TrackingEvent {
  AddPropertyFilter = `Add property filter`,
  AddSegment = `Add segment`,
  ClearSegment = `Clear segment`,
  EditPropertyFilter = `Edit property filter`,
  EditSegment = `Edit segment`,
  RemovePropertyFilter = `Remove property filter`,
  RemoveSegment = `Remove segment`,
  ReorderSegment = `Reorder segment`,
  SelectDateRange = `Select date range`,
  SelectSegment = `Select segment`,
  SelectBreakdownAttribution = `Select breakdown attribution`,
  SelectFunnelsBreakdownAttribution = `Select funnels breakdown attribution`,
}

/** Defines tracking events that will be tracked as part of the query-builder */
export const CAPTURED_TRACKING = new Set<string>([
  CollapsibleTrackingEvent.ClosedCollapsibleSection,
  CollapsibleTrackingEvent.OpenedCollapsibleSection,
  TrackingEvent.ReorderSegment,
  ...FlattenedResourceTrackingEvent,
  ...Object.values(EventSectionTrackingEvent),
  ...Object.values(PropertiesMenuTrackingEvent),
  ...Object.values(CohortsQueryBuilderTrackingEvent),
  ...Object.values(CustomPropertyModelTrackingEvent),
  ...Object.values(QueryBlockTrackingEvent),
]);
